import { render, staticRenderFns } from "./CoursePausedState.vue?vue&type=template&id=6dfb4802&scoped=true"
import script from "./CoursePausedState.vue?vue&type=script&lang=js"
export * from "./CoursePausedState.vue?vue&type=script&lang=js"
import style0 from "./CoursePausedState.vue?vue&type=style&index=0&id=6dfb4802&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dfb4802",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CoursePausedFloatingCard: require('/builds/marketing/abstracta.academy-website/components/CoursePausedFloatingCard.vue').default,HeaderMain: require('/builds/marketing/abstracta.academy-website/components/HeaderMain.vue').default})
